module.exports = __webpack_public_path__ + "static/media/add-phone-number.61fb2992.svg";